import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-20 pb-24 px-4 overflow-hidden bg-[#0A0A0A]" data-id="element-5">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#1A7A4A]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-6" />

      <div className="relative max-w-4xl mx-auto text-center" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-8">
          <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight leading-[1.1] mb-6" data-id="element-9">
            Trabajas 40 horas a la semana…
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#1A7A4A] to-[#C9A84C]" data-id="element-10">
              pero tu moneda vale cada vez menos
            </span>
          </h1>

          <h2 className="text-lg md:text-xl font-medium text-[#D1D5DB] mb-8" data-id="element-11">
            La guía paso a paso para empezar a cobrar en dólares desde
            Latinoamérica.
          </h2>

          <p className="text-lg md:text-xl text-[#D1D5DB]/80 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-12">
            Este manual es para quienes están hartos de que su sueldo valga
            menos cada mes y quieren su{' '}
            <span className="text-[#1A7A4A] font-semibold" data-id="element-13">
              primer sueldo en dólares
            </span>
            .
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4,
          duration: 0.5
        }} data-id="element-14">
            <CTAButton text="QUIERO SABER CÓMO GANAR EN DÓLARES" data-id="element-15" />
            <p className="mt-4 text-sm text-neutral-500 flex items-center justify-center gap-2" data-id="element-16">
              <span className="w-2 h-2 rounded-full bg-[#1A7A4A] animate-pulse" data-id="element-17" />
              Acceso inmediato tras la compra
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}